module.exports = "/assets/98f52a73e258003ffb025fb18433b0c2.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos-small/TK.png
// module id = 2979
// module chunks = 0